// extracted by mini-css-extract-plugin
module.exports = {"LoadingImage":"loadingdata_LoadingImage__Tirgv"};